var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSort(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.311 0.555H48.311V24.555H24.311z",
    opacity: 0.01,
    transform: "rotate(90 24.311 .555)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 6.312,
    y: 21.555,
    rx: 0.95,
    transform: "rotate(-90 6.312 21.555)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 11.312,
    y: 21.555,
    rx: 0.95,
    transform: "rotate(-90 11.312 21.555)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 2,
    x: 16.312,
    y: 21.555,
    rx: 0.95,
    transform: "rotate(-90 16.312 21.555)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.ffba458f9fd9c43b7bc610c38f298446.svg";
export { ForwardRef as ReactComponent };